import {Component, OnInit} from '@angular/core';
import {PdfdataService} from "../../services/pdfdata.service";
import {ActivatedRoute, Router} from "@angular/router";
import {ApiService} from "../../services/api.service";


/**
 * @ignore
 */
@Component({
    selector: 'app-viewpdf',
    templateUrl: './viewpdf.component.html',
    styleUrls: ['./viewpdf.component.css']
})
export class ViewpdfComponent implements OnInit {

    public finef: any;
    public paidfinef: any;
    public exp: string;
    public hash: string;
    public type: string;
    public finedata: any;
    public files = [];

    constructor(private pdfdataService: PdfdataService,
                private route: ActivatedRoute,
                private router: Router,
                private apiService: ApiService) {

        this.route.params.subscribe(params => {
            this.hash = params['hash'];
            this.type = params['type'];
            this.exp = params['exp'];
        });
    }

    ngOnInit() {
        this.files = JSON.parse(localStorage.getItem('expedientes'));
        this.apiService.getFineData(`${ this.hash }`, `${this.files[0]}`)
            .subscribe((response: any) => {

                    this.finedata = response;

                    if (this.finedata.estado == "pagado") {
                        // PDF paid Fine
                        this.pdfdataService.setURLPdf(response.ficheroJustificante, "paidfine");
                        this.paidfinef = this.pdfdataService.getURLPdf("paidfine");
                    }

                    // PDF Fine
                    this.pdfdataService.setURLPdf(response.ficheroMulta, "fine");
                    this.finef = this.pdfdataService.getURLPdf("fine");

                });

    }

    redirect() {
        this.router.navigate([`app/viewfine/${this.hash}`]);
    }

}
